var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.disabled)?_c('router-link',{attrs:{"to":'/' + _vm.$i18n.locale + '/' + _vm.to}},[_vm._t("default")],2):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }